window.onload = function() {
    const isOpened = localStorage.getItem('isReadyFoodModalOpened');
    const isOpenedParsed = JSON.parse(isOpened || true);

    if ($('#contactlessModal').length && isOpenedParsed) {
        const button = document.querySelector('.contactless-modal__btn');
        const onClose = () => localStorage.setItem('isReadyFoodModalOpened', false);

        button.addEventListener('click', onClose);

        $.magnificPopup.open({
            items: {
                src: '#contactlessModal'
            },
            type: 'inline',
            // showCloseBtn: false,
            closeBtnInside: true,
            mainClass: 'mfp-fade',
            callbacks: {
                close: onClose
            }
        });
    }
}
